'use client';
import React, { useState } from 'react';
import { When } from 'react-if';

import { Text } from '@nerdwallet/currency/components/Text';
import KeyboardArrowDownIcon from '@nerdwallet/react-icon/material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@nerdwallet/react-icon/material/KeyboardArrowUp';

import Collapse from '@components/nw-react-collapse';
import classes from '@nerdwallet/base-styles/classes';
import styles from './collapsible.module.scss';

export interface Props {
  isOpen?: boolean;
  label: string;
  numItems?: number;
  onOpen?: () => void;
  children: React.ReactNode;
}

const Collapsible: React.FC<Props> = ({
  isOpen = false,
  label,
  numItems,
  onOpen,
  children,
}) => {
  const [isOpenState, setIsOpenState] = useState<boolean>(isOpen);

  const toggle = () => {
    if (!isOpenState) {
      onOpen?.();
    }
    setIsOpenState((prevIsOpen) => !prevIsOpen);
  };

  const Icon = isOpenState ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;

  const content = (
    <div className={styles.wrapper}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Please fix */}
      <header
        onClick={toggle}
        className={classes(
          'padding-vertical-3',
          'cursor-pointer',
          'display-flex',
          'justify-content-space-between',
        )}
      >
        <Text component="span" bold>
          {label}
          <When condition={!!numItems}>{` (${numItems})`}</When>
        </Text>
        <Icon />
      </header>
      <Collapse isOpened={isOpenState}>{children}</Collapse>
    </div>
  );

  return content;
};

export default Collapsible;
